import useApi from './useApi';
import { useQuery } from '@tanstack/react-query';

interface ClientInfo {
  addline1?: string;
  addline2?: string;
  addline3?: string;
  client_code: string;
  client_id: number;
  company_name: string;
  country?: string;
  email?: string;
  enabled: boolean;
  info_tags: boolean;
  logo_url?: string;
  nhs_client: boolean;
  no_users?: number;
  ods_code?: string;
  postcode?: string;
  region?: string;
  telephone_no?: string;
  self_refer?: boolean;
}

interface UseFetchClientListParams {
  [key: string]: any;
}

const defaultParams: UseFetchClientListParams = {
  rows: 999,
  order: 'asc',
  sort: 'name'
};

export default function useFetchClientList(params: UseFetchClientListParams = {}): ClientInfo[] {
  const { Api } = useApi();
  const { data: clientList } = useQuery({
    queryKey: ['allClients', params],
    queryFn: () =>
      Api.admin.company.getAll({
        ...defaultParams,
        ...params
      }) as Promise<{ data: { companies: ClientInfo[] } }>,
    select: (data) => data.data.companies || []
  });

  return clientList || [];
}
